import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import CuratedContentArticleTable from 'Components/UI/CuratedContentArticleTable';

const styles = () => ({
  root: {
    width: '100%',
  },
});

const CuratedContentArticles = ({
  className,
  classes,
}) => {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Planner Settings',
    isPageView: true,
  });

  return (
    <Box
      className={classNames(classes.root, className)}
      test="curated-content-articles-root"
      {...rootNodeProps}
    >
      <CuratedContentArticleTable />
    </Box>
  );
};

CuratedContentArticles.defaultProps = {
  className: '',
};

CuratedContentArticles.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CuratedContentArticles);
